import { render, staticRenderFns } from "./event315.vue?vue&type=template&id=044f211e&scoped=true&"
import script from "./event315.vue?vue&type=script&lang=js&"
export * from "./event315.vue?vue&type=script&lang=js&"
import style0 from "./event315.vue?vue&type=style&index=0&id=044f211e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044f211e",
  null
  
)

export default component.exports